import axios from 'axios';

export default() => {
    return axios.create({
        baseURL: 'https://us-central1-clinicadelnorte-56bef.cloudfunctions.net/api',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    });
}